module.exports = __webpack_public_path__ + "img/国防科技大学实试验训练基地.a3900401.png";